import { useMemo } from 'react';
import { useSpotMarkets } from './useSpotMarkets';

export const useSpotMarketsLookup = () => {
	const spotMarkets = useSpotMarkets();
	const maxSpotMarketIndex = useMemo(
		() => Math.max(...spotMarkets.map((market) => market.marketIndex)),
		[spotMarkets]
	);
	return useMemo(() => {
		const lookup = new Array(maxSpotMarketIndex > 0 ? maxSpotMarketIndex : 1);

		spotMarkets.forEach((market) => {
			lookup[market.marketIndex] = market;
		});

		return lookup;
	}, [spotMarkets, maxSpotMarketIndex]);
};
